import { useEffect, useRef } from 'react';

/**
 * Runs the effect only on updates (skips initial mount).
 * @param {Function} effect - can return a cleanup function
 * @param {Array} deps - dependency array (same rules as useEffect)
 */

const useUpdateOnly = (effect, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    return effect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useUpdateOnly;
